import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
  en: {
    verticalColon: ':',

    // button
    actionsButton: 'Actions',
    addButton: 'Add',
    authorizeButton: 'Authorize',
    backButton: 'Back',
    bulkEditButton: 'Bulk Edit',
    cancelButton: 'Cancel',
    clearButton: 'Clear',
    closeButton: 'Close',
    confirmButton: 'Confirm',
    ConfirmRemoveModalYesRemoveButton: 'Yes, remove',
    deleteButton: 'Delete',
    doneButton: 'Done',
    editButton: 'Edit',
    editMoreButton: 'Edit More',
    exportCSVButton: 'Export CSV',
    nextButton: 'Next',
    noButton: 'No',
    printButton: 'Print',
    removeButton: 'Remove',
    saveButton: 'Save',
    submitButton: 'Submit',
    yesButton: 'Yes',

    // column header
    columnHeaderActions: 'Actions',

    componentHeaderAdminButton: 'Go to Admin Portal',
    componentHeaderLogoutButton: 'Logout',
    confirmationHeader: 'Confirmation',
    componentContinueButton: 'Continue',

    navigationAdminAccountDevicesTitle: 'Devices',
    navigationAdminAccountVaultsTitle: 'Vaults',
    navigationAdminAccountReportsTitle: 'Reports',
    navigationAdminAccountTitle: 'Profile',
    navigationAdminOrganizationAccountsTitle: 'Users',
    navigationAdminOrganizationDashboardTitle: 'Dashboard',
    navigationAdminOrganizationTitle: 'Details',
    navigationAdminOrganizationReportsTitle: 'Reports',
    navigationAdminOrganizationUsersReportsTitle: 'Users',
    navigationAdminOrganizationLicensesReportsTitle: 'Licenses',
    navigationAdminOrganizationSettingsTitle: 'Settings',
    navigationAdminOrganizationsTitle: 'Companies',
    navigationAdminOrganizationsUsegeAndAccessTitle: 'Usage & Access',
    navigationAdminOrganizationsInstallationsTitle: 'Installations',
    navigationAdminOrganizationsNewAccountsTitle: 'New Accounts',
    navigationAdminOrganizationsActiveUsersTitle: 'Active Users',

    navigationUserProfileDashboardTitle: 'Dashboard',
    navigationUserProfileDevicesTitle: 'Devices',
    navigationUserProfileVaultsTitle: 'Vaults',
    navigationUserProfileReportsTitle: 'Reports',
    navigationUserProfileTitle: 'Profile',
    navigationUserProfileAccountTitle: 'Account',
    navigationUserProfileAliasesTitle: 'Aliases',
    navigationUserProfileEncryptsAndDecryptsTitle: 'Encrypts/Decrypts',

    navigationAppsEBAgentTitle: 'Côntrol Agentless',
    navigationAppsDownloadsTitle: 'Downloads',
    navigationAppsOneDriveTitle: 'One Drive',
    navigationAppsGmailTitle: 'Gmail',
    navigationAppsDropboxTitle: 'Dropbox',
    navigationAppsAndroidTitle: 'Android',
    navigationAppsiOSTitle: 'iOS',
    navigationAppsMacOSTitle: 'macOS',
    navigationAppsWindownsOSTitle: 'Windows',
    navigationAppsOutlookTitle: 'Outlook Add-in',

    pageAdminOrganizationsNoCompany:
      'There are no companies. Please click on the ‘Add Company’ button.',
    pageAdminOrganizationsNoCompanyFilter:
      'There are no companies that match your search criteria.',

    pageAdminOrganizationCompanyTitle: 'Company Details',
    pageAdminOrganizationEditCompanyTitle: 'Edit Company Details',
    pageAdminOrganizationAddCompanyTitle: 'Add Company Details',
    pageAdminOrganizationShowAdmin: 'Show Administrators',
    pageAdminOrganizationHideAdmin: 'Hide Administrators',
    pageAdminOrganizationMemberSince: 'Member Since',
    pageAdminOrganizationAdminListEmpty: 'No company administrators',
    pageAdminOrganizationAdminTitle: 'Administrator',
    pageAdminOrganizationConfirmRemoveModalContent:
      'Are you sure you want to remove ${email} as a company administrator?',
    pageAdminOrganizationRemoveAdministrator:
      'Success! The company administrator has been removed.',

    pageAdminOrganizationAccountEmailColumn: 'Email',
    pageAdminOrganizationAccountFirstColumn: 'First',
    pageAdminOrganizationAccountLastColumn: 'Last',
    pageAdminOrganizationAccountCompanyColumn: 'Company',
    pageAdminOrganizationAccountStatusColumn: 'Status',
    pageAdminOrganizationAccountStandardStatus: 'Standard',
    pageAdminOrganizationAccountNoresults:
      'There are no users that match your search criteria.',
    pageAdminOrganizationAccountNoUsers:
      'There are no users. Please click on the ‘Add User’ button.',
    pageAdminOrganizationAccountNoDevices:
      'There are no devices authorized for Côntrol software for this user.',
    pageAdminOrganizationAccountTitle: 'Users',
    pageAdminOrganizationAccountSearchText:
      'Filter by Email, First Name and Last Name...',
    pageAdminOrganizationAddUserButton: 'Add User',

    pageAdminOrganizationCompanyNameColumns: 'Name',
    pageAdminOrganizationCompanyTypeColumns: 'Type',
    pageAdminOrganizationCompanyTitleList: 'Companies',
    pageAdminOrganizationCompanySearchText: 'Filter by Company...',
    pageAdminOrganizationAccountAddCompanyButton: 'Add Company',

    pageAdminOrganizationCompanyDetailNameField: 'Name',
    pageAdminOrganizationCompanyDetailTypeField: 'Type',
    pageAdminOrganizationCompanyDetailAbbreviationField: 'Abbreviation',
    pageAdminOrganizationCompanyDetailCountryField: 'Country',
    pageAdminOrganizationCompanyDetailAddress1Field: 'Address, Line 1',
    pageAdminOrganizationCompanyDetailAddress2Field: 'Address, Line 2',
    pageAdminOrganizationCompanyDetailCityField: 'City',
    pageAdminOrganizationCompanyDetailStateField: 'State/Territory',
    pageAdminOrganizationCompanyDetailPostalField: 'Postal Code',
    pageAdminOrganizationCompanyDetailTrialField: 'Trial Mode',
    pageAdminOrganizationCompanyDetailLicensesField: 'Licenses Available',
    pageAdminOrganizationCompanyDetailExpirationField: 'Expiration Date',
    pageAdminOrganizationCompanyDetailTechnicalField: 'Technical Contact',
    pageAdminOrganizationCompanyDetailBillingField: 'Billing Contact',
    pageAdminOrganizationCompanyDetailAccountManagerField: 'Account Manager',
    pageAdminOrganizationCompanyDetailMemberSinceField: 'Member Since',
    pageAdminOrganizationCompanyDetailTitle: 'Company Details',
    pageAdminOrganizationCompanyDetailEditButton: 'Edit',
    pageAdminOrganizationCompanyDetailHideButton: 'Hide',
    pageAdminOrganizationCompanyDetailShowButton: 'Show',
    pageAdminOrganizationCompanyDetailAdministratorsButton: 'Administrators',

    pageAdminOrganizationReportBackButton: '⬅ Back',
    pageAdminOrganizationReportTitle: 'Reports',
    pageAdminOrganizationReportUsageAccess: 'Usage and Access Rights Report',
    pageAdminOrganizationReportRightsColumn: 'Rights',
    pageAdminOrganizationReportTotalColumn: 'Total',
    pageAdminOrganizationReportAverageColumn: 'Average',
    pageAdminOrganizationReportAuthorizedUsers: 'Authorized Accessors',
    pageAdminOrganizationReportSecureContainers: 'Vaults',
    pageAdminOrganizationReportLocationAccess: 'Location Access',
    pageAdminOrganizationReportDate: 'Date',
    pageAdminOrganizationReportPreventCopy: 'Prevent Copy',
    pageAdminOrganizationReportPreventForward: 'Prevent Forward',
    pageAdminOrganizationReportPreventPrint: 'Prevent Print',
    pageAdminOrganizationReportPreventSave: 'Prevent Save',
    pageAdminOrganizationReportRevoke: 'Revoke',
    pageAdminOrganizationReportShred: 'Shred',
    pageAdminOrganizationReportAccessTimes: 'Access Times',

    pageAdminOrganizationReportDesUsage:
      'Access and usage rights that were enabled on vaults.',
    pageAdminOrganizationReportUsageAccessNote1:
      '1. Data can change over time because usage and access rights can be edited.',
    pageAdminOrganizationReportUsageAccessNote2:
      '2. Global settings at the company level may have an impact on data.',
    pageAdminOrganizationReportUsageAccessTotalVaults: 'Total Vaults Created',
    pageAdminOrganizationReportUsageAccessTotalAccessors:
      'Total Authorized Accessors',

    pageAdminOrganizationReportEncrypts: 'Encrypts/Decrypts Report',
    pageAdminOrganizationReportDesEncrypts:
      'Encryptions and decryptions by data author.',
    pageAdminOrganizationReportInstallations: 'Installations Report',
    pageAdminOrganizationReportDesInstallations:
      'Côntrol installations by platform.',
    pageAdminOrganizationReportNewAccounts: 'New Accounts Report',
    pageAdminOrganizationReportDesNewAccounts: 'Unique users by license type.',
    pageAdminOrganizationReportActiveUsers: 'Active Users Report',
    pageAdminOrganizationReportDesActiveUsers:
      'Unique usage by Côntrol application.',
    pageAdminOrganizationReportActiveUsersNote1:
      '1. Activity is defined as registrations, encryptions, decryptions, shredding, revoking, and portal activity.',
    pageAdminOrganizationReportActiveUsersNote2:
      '2. Users are only counted once regardless of how many activities they performed in the date range.',
    pageAdminOrganizationReportCloseButton: 'Close',
    pageAdminOrganizationReportViewButton: 'View',
    pageAdminOrganizationReportNotes: 'Notes',
    pageAdminOrganizationReportFirstNote:
      '1. Installations are only counted once per device regardless of how many accounts are using the device.',
    pageAdminOrganizationReportSecondNote:
      '2. Users are only counted once regardless of how many activities they performed in the date range.',
    pageReportName: 'Name',
    pageReportPlatform: 'Platform',
    pageReportAmount: 'Amount',
    pageActiveUsersReportTitle: 'Active Users',
    pageReportDateRange: 'Date Range:',
    pageReportsButton: 'Reports',
    pageReportTableViewButton: 'Table View',
    pageReportAreaChartButton: 'Area Chart',
    pageReportPieChartButton: 'Pie Chart',
    pageReportBarChartButton: 'Bar Chart',
    pageReportLineChartButton: 'Line Chart',
    pageReportDonutChartButton: 'Donut Chart',
    pageReportAverageChartButton: 'Average Chart',
    pageReportNoDataAvailable: 'No data available',
    pageReportNoData: 'No data available for this time period.',
    pageReportLegendPlatformsTitle: 'Platforms',
    pageReportLegendApplicationTitle: 'Application',
    pageReportExportConfirmation:
      'There is no data for the time period selected.<br/> Do you still want to export this report?',
    pageReportPrintConfirmation:
      'There is no data for the time period selected.<br/> Do you still want to print this report?',

    pageEncrytedReportsEmail: 'Email',
    pageEncrytedReportsEncrypts: 'Encrypts',
    pageEncrytedReportsDecrypts: 'Decrypts',
    pageEncrytedReportsTitle: 'Encrypts and Decrypts',

    pageInstallationsReportsWindows: 'WINDOWS',
    pageInstallationsReportsMac: 'MAC',
    pageInstallationsReportsWeb: 'WEB',
    pageInstallationsReportsAndroid: 'ANDROID',
    pageInstallationsReportsIphone: 'IPHONE',
    pageInstallationsReportsTitle: 'Installations',
    pageInstallationsReportsPlatforms: 'Platforms',
    pageInstallationsReportsTotal: 'Total',
    pageInstallationsReportsAverage: 'Average',

    pageRegistrationReportsTitle: 'New Accounts',
    pageRegistrationReportsLicenseType: 'License Type',
    pageRegistrationReportsFree: 'Free',
    pageRegistrationReportsProfessional: 'Professional',
    pageRegistrationReportsTotal: 'Total',
    pageRegistrationReportsAverage: 'Average',

    pageUserReportsDate: 'Date',
    pageUserReportsCountAmount: 'Count amount',
    pageUserReportsAuthorized: 'Authorized user count',
    pageUserReportsGeofencing: 'Geofencing set count',
    pageUserReportsTotal: 'Total',
    pageUserReportsPreventCopy: 'Prevent Copy Count',
    pageUserReportsPreventSave: 'Prevent Save Count',
    pageUserReportsPreventPrint: 'Prevent Print Count',
    pageUserReportsPreventForward: 'Prevent Forward Count',
    pageUserReportsTimeline: 'Timeline Set Count',
    pageUserReportsSharedCount: 'Shared Count',
    pageUserReportsRevokeCount: 'Revoke Count',
    pageUserReportsAverage: 'Average',
    pageUserReportsTitle: 'Usage & Access',

    pageAdminOrganizationSettingTitle: 'Settings',
    pageAdminOrganizationSettingDomains: 'Domains',
    pageAdminOrganizationSettingDesDomains:
      'This section lists any domains that are owned by your company. All users that have an email address with a matching domain name will automatically be placed as users in the company account. Please contact a Vengar Technologies administrator to make any changes.',
    pageAdminOrganizationSettingHideButton: 'Hide',
    pageAdminOrganizationSettingShowButton: 'Show',
    pageAdminOrganizationSettingDetailsButton: 'Details',
    pageSettingsAddDomains: 'Add Domains',
    pageSettingsAddDomainsEmpty:
      'There are no domains added to this company yet.',
    pageSettingsAddDomainsInputTitle: 'Enter the company owned domain name',
    pageSettingsDomainConfirmQuestion:
      'Are you sure you want to remove ${domain}?',

    pageEditOrganizationName: 'Name',
    pageEditOrganizationType: 'Type',
    pageEditOrganizationAbbreviation: 'Abbreviation',
    pageEditOrganizationCountry: 'Country',
    pageEditOrganizationAddressLine1: 'Address, Line 1',
    pageEditOrganizationAddressLine2: 'Address, Line 2',
    pageEditOrganizationCity: 'City',
    pageEditOrganizationStateTerritory: 'State/Territory',
    pageEditOrganizationPostalCode: 'Postal Code',
    pageEditOrganizationLicenses: 'Licenses',
    pageEditOrganizationTrialMode: 'Trial Mode',
    pageEditOrganizationTotalLicenses: 'Total Licenses',
    pageEditOrganizationExpirationDate: 'Expiration Date',
    pageEditOrganizationTechnicalContact: 'Technical Contact',
    pageEditOrganizationContactFirstName: 'First Name',
    pageEditOrganizationContactLastName: 'Last Name',
    pageEditOrganizationContactEmail: 'Email',
    pageEditOrganizationContactPhoneNumber: 'Phone Number',
    pageEditOrganizationBillingContact: 'Billing Contact',
    pageEditOrganizationAccountManager: 'Account Manager',
    pageEditOrganizationOptionSelectType: 'Select Type',
    pageEditOrganizationOptionSelectCountry: 'Select Country',
    pageEditOrganizationOptionSelectStateTerritory: 'Select State/Territory',

    pageNoVaults: 'No Vaults',
    pageVaultsFilters: 'Filters',
    pageVaultsDateColumn: 'Date',
    pageVaultsDataOwnerColumn: 'Data Owner',
    pageVaultsUsersColumn: 'Accessors',
    pageVaultsTitleColumn: 'Title',
    pageVaultsSizeColumn: 'Size',
    pageVaultsNotesColumn: 'Notes',
    pageVaultsFilesColumn: 'Files',
    pageVaultsDataTypeColumn: 'Data Type',
    pageVaultsUsageAccessColumn: 'Access & Usage Rights',
    pageVaultsTitle: 'Vaults',
    pageVaultsDRMEnabled: 'On',
    pageVaultsDRMDisabled: 'Off',
    pageVaultsPreventCopy: 'Prevent Copy',
    pageVaultsPreventPrint: 'Prevent Print',
    pageVaultsPreventSave: 'Prevent Save',
    pageVaultsReadReceipts: 'Request Read Receipts',
    pageVaultsPreventForward: 'Prevent Forward',
    pageVaultsAccessTimes: 'Access Times',
    pageVaultsLocationAccess: 'Location Access',
    pageVaultsShred: 'Shred',
    pageVaultsShredded: 'Vault Shredded',
    pageVaultsNotShredded: 'Vault Not Shredded',
    pageVaultsRevoked: 'Vault Revoked',
    pageVaultsNotRevoked: 'Vault Not Revoked',
    pageVaultsRevokeAll: 'Revoke All',
    pageVaultsRevoke: 'Revoke',
    pageVaultsNA: 'N/A',
    pageVaultsHasNotes: 'Vault has notes',
    pageVaultsSharedBy: 'Shared By:',
    pageVaultsNotFoundAuthorizedAccessors:
      'No authorized users match that search criteria.',
    pageVaultsFilterAuthorizedAccessors: 'Filter by authorized accessor...',
    pageVaultsNoAuthorizedAccessors: 'No Authorized Accessors',
    pageVaultsUpgradeButton: 'Upgrade',
    pageVaultsUpgradeRequired: 'Upgrade Required',
    pageVaultsUpgradeContent:
      'The ability to view vault details, including the ability to see access maps and activity logs requires you to upgrade your license. <br/> <br/> Click the UPGRADE button to start maximizing your ability to control your data!',
    pageVaultsConfirmShredContentLine1:
      'The SHRED button <span style="color: #F0395A">permanently</span> prevents the vault from ever being decrypted by anyone, including you, the data author. This action is <span style="color: #F0395A">NOT</span> reversible.',
    pageVaultsConfirmShredContentLine2:
      'Please type SHRED in the input box below and click on the ‘Yes, Shred‘ button to destroy access to this vault.',

    pageVaultDetailsTitle: 'Vault Details',
    pageVaultEditTitle: 'Edit Vault',
    pageVaultDetailsOverview: 'Overview',
    pageVaultDetailsDateField: 'Date',
    pageVaultDetailsTimeField: 'Time',
    pageVaultDetailsDataOwnerField: 'Data Owner',
    pageVaultDetailsTitleField: 'Title',
    pageVaultDetailsStatusField: 'Status',
    pageVaultDetailsAuthorizedAccessors: 'Authorized Accessors',
    pageVaultDetailsAuthorizedAccessorHasRead: 'User Decrypted Vault',
    pageVaultDetailsAuthorizedAccessorHasNotRead:
      'User Has NOT Decrypted Vault',
    pageVaultDetailsAuthorizedAccessoredRevoked: 'User Access Revoked',
    pageVaultDetailsAuthorizedAccessoredNotRevoked: 'User Has Access',
    pageVaultDetailsAccessUsageRights: 'Usage Rights',
    pageVaultDetailsNow: 'Now',
    pageVaultDetailsTo: 'To',
    pageVaultDetailsStartTime: 'Start Time',
    pageVaultDetailsEndTime: 'End Time',
    pageVaultDetailsLocationAccess: 'Location Access',
    pageVaultDetailsAllowed: 'Allowed',
    pageVaultDetailsNotAllowed: 'Not Allowed',
    pageVaultDetailsEverywhereElse: 'Everywhere Else',
    pageVaultDetailsForever: 'Forever',
    pageVaultDetailsEverywhere: 'Everywhere',
    pageVaultDetailsPopoverTitleDescriptions:
      'The title is a short description given to your vault. It may or may not match the filename.',
    pageVaultDetailsPopoverUsageRightsDescriptions:
      'Select the usage rights you would like to enforce on your data.',
    pageVaultDetailsPopoverAccessTimeDescriptions:
      'Select the time period that your data can be accessed.',
    pageVaultDetailsPopoverLocationAccessDescriptions:
      'Select the locations where you would like your data to be viewed from.',
    pageVaultDetailsConfirmRevokeQuestion:
      'The REVOKE button removes access to your vault for ALL authorized accessors. <br/> <br/>Are you sure you want to REVOKE access for ALL authorized accessors?',
    pageVaultDetailsConfirmRevoke: 'Yes, revoke',
    pageVaultDetailsConfirmShredQuestion: 'Are you sure you want to shred?',
    pageVaultDetailsConfirmShred: 'Yes, shred',
    pageVaultDataOwner: ' (Data Owner)',
    pageVaultDetailsUserField: 'User',
    pageVaultDetailsEventTypeField: 'Event Type',
    pageVaultDetailsField: 'Details',
    pageVaultDetailsAppField: 'Application',
    pageVaultDetailsCountryField: 'Country',
    pageVaultDetailsActivityLog: 'Vault Activity Log',
    pageVaultErrorDateTime: 'Start Time must be less than End Time.',
    pageVaultErrorEndTime:
      'The End Time must be greater than the current date time.',

    pageVaultShredCanNotEdit:
      'This vault has a status of SHRED.<br/> <br/>Shredded vaults can NOT be edited.',

    pageVaultEditRemoveEmail:
      'Are you sure you want to revoke access for ${email}?',
    pageVaultEditAddAuthorAccessorEmail:
      'Are you sure you want to add ${email} back as an authorized user?',
    pageVaultEditStartNow: 'Start Now',
    pageVaultEditStartSpecific: 'Start on specific day and time',
    pageVaultEditStartTime: 'Start Time',
    pageVaultEditNeverEnds: 'Never Ends',
    pageVaultEditEndSpecific: 'End on specific day and time',
    pageVaultEditEndTime: 'End Time',
    pageVaultEditAll: 'All',
    pageVaultEditIncluded: 'Included',
    pageVaultEditExcluded: 'Excluded',
    pageVaultEditAuthorized: 'Authorized',
    pageVaultEditRevoked: 'Revoked',
    pageVaultEditSearchPlaceholder: 'Search Country...',
    pageVaultEditAllCountries: 'Include/Exclude All Countries',
    pageVaultEditFilterListBy: 'Filter View:',
    pageVaultEditRequiredTitle: 'Title is required',
    pageVaultAddAuthorAccessRequiredEmail:
      'Authorized accessor email is required',
    pageVaultAddAuthorAccessValidEmail: 'Email must be a valid email',
    pageVaultAddAuthorAccessEmailExists: 'Email already exists',
    pageVaultAddAuthorAccessEmail: 'Email',
    pageVaultAddAuthorAccess: 'Add Authorized Accessor',
    pageBulkEditVaultTitle: 'Bulk Edit Vaults',
    pageBulkEditVaultStepSelectVaults: 'Step 1 of 4: Select Vaults',
    pageBulkEditVaultEditRights: 'Edit Rights',
    pageBulkEditVaultEditRightsDescription:
      'Change how authorized accessors can use data',
    pageBulkEditVaultAddAccessorsDescription:
      'Add vault access for specific individuals',
    pageBulkEditVaultRevokeAccessors: 'Revoke Accessors',
    pageBulkEditVaultRevokeAccessorsDescription:
      'Revoke vault access for specific individuals',
    pageBulkEditVaultEditAccessTime: 'Edit Access Time',
    pageBulkEditVaultEditAccessTimeDescription:
      'Change when authorized accessors can use data',
    pageBulkEditVaultEditLocationAccessDescription:
      'Change where authorized accessors can use data',
    pageBulkEditVaultRevokeAllAccess: 'Revoke All Access',
    pageBulkEditVaultRevokeAllAccessDescription:
      'Revoke access for ALL authorized accessors',
    pageBulkEditVaultShredVaultsDescription:
      'Shred access for everyone, including the data owner',
    pageBulkEditVaultStepChooseAction: 'Step 2 of 4: Choose Action',
    pageBulkEditVaultOperationDetails: 'Step 3 of 4: Operation Details',
    pageBulkEditVaultAddAccessorsOperation:
      'Add vault access for specific individuals to the selected vaults.',
    pageBulkEditVaultRightsOperation:
      'Check the right you would like to edit to make it active and then select if you want to enable or disable the selected right.',
    pageBulkEditVaultAccesssTimeOperation:
      'Select when you would like authorized accessors to be able to use the data shared with them.',
    pageBulkEditVaultLocationAccessOperation:
      'Select where you would like authorized accessors to be able to use the data shared with them.',
    pageBulkEditVaultShredVaultsOperation: 'Shred access to vaults.',
    pageBulkEditVaultRevokeAllAccessOperation:
      'Revoke access for all accessors.',
    pageBulkEditVaultPreventAccessorForwarding:
      'Prevent accessor from forwarding',
    pageBulkEditVaultPreventAccessorCopying: 'Prevent accessor from copying',
    pageBulkEditVaultPreventAccessorPrinting: 'Prevent accessor from printing',
    pageBulkEditVaultPreventAccessorSaving: 'Prevent accessor from saving',
    pageBulkEditVaultForward: 'Forward',
    pageBulkEditVaultFilesCanForwarded: 'Files can be forwarded.',
    pageBulkEditVaultFilesCannotForwarded: 'Files cannot be forwarded.',
    pageBulkEditVaultCopy: 'Copy',
    pageBulkEditVaultFilesCanCopied: 'Files can be copied.',
    pageBulkEditVaultFilesCannotCopied: 'Files cannot be copied.',
    pageBulkEditVaultPrint: 'Print',
    pageBulkEditVaultFilesCanPrinted: 'Files can be printed.',
    pageBulkEditVaultFilesCannotPrinted: 'Files cannot be printed.',
    pageBulkEditVaultSave: 'Save',
    pageBulkEditVaultFilesCanSaved: 'Files can be saved locally.',
    pageBulkEditVaultFilesCannotSaved: 'Files cannot be saved locally.',
    pageBulkEditVaultCongratulationsTitle: 'Congratulations!',
    pageBulkEditVaultRightsSet: 'Rights Set',
    pageBulkEditVaultSuccessfullyEditedRights:
      'You have successfully edited rights on ${count} Vaults!',
    pageBulkEditVaultSuccessfullyAddAccessors:
      'You have successfully added the following accessors to ${count} Vaults!',
    pageBulkEditVaultSuccessfullyLocationAccess:
      'You have successfully edited the location access for ${count} Vaults!',
    pageBulkEditVaultSuccessfullyEditAccessTime:
      'You have successfully edited the access timeline for ${count} Vaults!',
    pageBulkEditVaultSuccessfullyRevokeAllAccess:
      'You have successfully revoked access for ${count} Vaults!',
    pageBulkEditVaultSuccessfullyRevokedAccessors:
      'You have successfully revoked the following accessors from ${count} Vaults!',
    pageBulkEditVaultStepConfirmation: 'Step 4 of 4: Confirmation',
    pageBulkEditVaultConfirmationDescriptions:
      'Click the Confirm button to implement the Selected Actions on the Selected Vaults.',
    pageBulkEditVaultSelectedActions: 'Selected Actions',
    pageBulkEditVaultAddAccessors: 'Add Accessors',
    pageBulkEditVaultAction: 'Action',
    pageBulkEditVaultDetails: 'Details',
    pageBulkEditVaultEditLocationAccess: 'Edit Location Access',
    pageBulkEditVaultEditAccessTimeline: 'Edit Access Timeline',
    pageBulkEditVaultSelectedVaults: 'Selected Vaults',
    pageBulkEditVaultCountriesAllowed: 'Countries Allowed',
    pageBulkEditVaultDate: 'Date',
    pageBulkEditVaultAddAuthorized:
      'Add vault access for specific individuals to the selected vaults.',
    pageBulkEditVaultDragDropAuthorizedAccessors:
      'Drag and drop authorized accessors from one list to the other as desired.',
    pageBulkEditVaultPleaseTypeREVOKE:
      'Please type REVOKE in the input box below and click on the ‘Next’ button to revoke access for ALL accessors.',
    pageBulkEditVaultTypeWordREVOKE: 'Type the word “REVOKE”',
    pageBulkEditVaultPleaseTypeSHRED:
      'Please type SHRED in the input box below and click on the ‘Next’ button to proceed with destroying access to the selected vaults for ALL accessors, including the DATA OWNER.',
    pageBulkEditVaultTypeEmailAddress:
      'Type email address and click ‘Add’ button',
    pageBulkEditVaultEmailAddress: 'Email Address',
    pageBulkEditVaultAdditionalAccessorList: 'Additional Accessor List:',
    pageBulkEditVaultShreddingVaultsNOTReversible:
      'Shredding vaults is permanent and is NOT reversible.',
    pageBulkEditVaultALLSelectedVaultsShredded:
      'ALL selected vaults have been shredded.',
    pageBulkEditVaultALLAccessorsRemoved:
      'ALL accessors have been removed from all selected vaults.',
    pageBulkEditVaultTimelineSet: 'Timeline Set',
    pageBulkEditVaultAccessorsAdded: 'Accessors Added',
    pageBulkEditVaultShredVaults: 'Shred Vaults',
    pageBulkEditVaultRevokedAccessors: 'Revoked Accessors',
    pageBulkEditVaultNowhere: 'Nowhere',
    pageBulkEditVaultCountriesNotAllowed: 'Countries Not Allowed',
    pageBulkEditVaultRemoveALLAccessors: 'Remove access for ALL accessors',
    pageBulkEditVaultTitles: 'Title',
    pageBulkEditVaultRevokedAccessorsList: 'Revoked Accessors List',
    pageBulkEditVaultRevokedAccessorsDesc:
      'Individuals below will have their access revoked.',
    pageBulkEditVaultRevokedAccessorsPlaceholder:
      'Search Removed Accessor List...',
    pageBulkEditVaultCurrentAccessorsList: 'Current Accessors List',
    pageBulkEditVaultCurrentAccessorsDesc:
      'Individuals below are currently authorized accessors.',
    pageBulkEditVaultCurrentAccessorsPlaceholder:
      'Search Current Accessor List...',
    pageVaultDetailsAccessMap: 'Access Map',
    pageVaultDetailsDecryptionFailure: 'Decryption Failure',
    pageVaultDetailsDecryptionSuccess: 'Decryption Success',
    pageVaultDetailsDecryption: 'Decryption',
    pageBulkEditVaultWarningExcludeLocation:
      'You must select at least one country that the vault can be opened in.',
    pageBulkEditVaultAttentionStatusShred: `You have selected {count} vaults that have a status of SHRED.
        <br/> <br/>
        Shredded vaults can NOT be edited.
        <br/> <br/>
        Click the PROCEED button to automatically remove vaults that have a status of SHRED and continue the bulk editing process.
        `,
    pageBulkEditVaultAttentionAllStatusShred: `All of the selected vaults have a status of SHRED.
        <br/> <br/>
        Shredded vaults can NOT be edited.
        <br/> <br/>
        Click the CANCEL button to exit the bulk editing process and close this window.
        `,

    pageIndexUserPortalButton: 'Go to User Portal',
    pageIndexUserPortalDescription:
      "You're not authorized to view the admin pages; you'll need to log into the user portal to continue.",
    pageDashboardTitle: 'Dashboard',

    pageUserProfileTitle: 'Account',
    pageUserEditProfileTitle: 'Edit Account',
    pageUserCreateProfileTitle: 'Create Account',
    pageUserProfileTrial: 'Trial',
    pageUserProfileFirstName: 'First Name',
    pageUserProfileLastName: 'Last Name',
    pageUserProfileEmail: 'Email',
    pageUserProfileCountry: 'Country',
    pageUserProfileLogin: 'Login',
    pageUserProfilePassword: 'Password',
    pageUserProfileLicenseType: 'License Type',
    pageUserProfileRole: 'Role',
    pageUserProfileStatus: 'Status',
    pageUserProfileMemberSince: 'Member Since',
    pageUserProfileResetPasswordMessage:
      'Are you sure you want to reset the password for ',
    pageUserProfileUpgradeButton: 'Upgrade',
    pageUserProfileChangeButton: 'Change',
    pageUserProfileResetButton: 'Reset',
    pageUserProfileDeleteAccountButton: 'Remove Account',
    pageUserProfileStandard: 'Standard',
    pageUserProfileNotificationFreeUser:
      'Your free trial account will end ${date}. Click the ‘Upgrade’ button to keep enjoying the benefits of the full version of Côntrol.',
    pageUserProfileLicense: 'License',
    pageUserProfileExpirationDate: 'Expiration Date',
    pageUserProfileOptionSelectStatus: 'Select Status',
    pageUserProfileOptionSelectRole: 'Select Role',
    pageUserProfileOptionSelectLicense: 'Select License',
    pageUserProfileOptionSelectCountry: 'Select Country',
    pageUserProfileMFA: 'MFA',
    pageUserProfileMFAPopoverBody:
      'Enhance login security for the portal by requiring multi-factor authentication',
    pageUserProfileMFASetup: 'Setup',
    pageUserProfileAccountStatus: 'Account Status',

    leftMenuNavigation: 'NAVIGATION',
    leftMenuApps: 'APPS',
    pageUserAliasTitle: 'Aliases',
    pageUserAlias: 'Aliases',
    pageUserAliasEmailColumnTitle: 'Email',
    pageUserAliasStatusColumnTitle: 'Status',
    pageUserAliasActionsColumnTitle: 'Actions',
    pageUserAliasBackButton: 'Back',
    pageUserAliasAddButton: 'Add Alias',
    pageUserAliasConfirmButton: 'Confirm',
    pageUserAliasResendButton: 'Resend',
    pageUserAliasConfirmQuestion: 'Are you sure you want to remove ${email}?',
    pageUserAliasNoAliases: 'No aliases have been added',
    pageUserAliasActiveStatus: 'Active',
    pageUserAliasPendingStatus: 'Pending',
    pageUserAliasResendError:
      'Too many resend attempts. Please wait a bit and try again.',
    pageUserAliasResendQuestion:
      'Are you sure you want to resend the confirmation code? The previous code will no longer be valid.',
    pageUserAliasResendCodeButton: 'Resend Code',

    pageUserAliasModalCodeLength: 'Code must be 6 digits',
    pageUserAliasModalConfirmTitle: 'Confirm Email',
    pageUserAliasModalConfirmDescription:
      'An email with a confirmation code has been sent to your alias address. Enter the code to continue.',
    pageUserAliasModalCodeRequired: 'Code is required',
    pageUserAliasModalCodeMatches: 'Code can only have numeric characters',
    pageUserAliasModalConfirmCloseButton: 'Close',
    pageUserAliasModalConfirmConfirmButton: 'Confirm',

    pageUserDevicesTitle: 'Devices',
    pageUserDevicesNoDevices:
      'There are no devices authorized for Côntrol software. Please install Côntrol on your preferred device.',
    pageUserDevicesDeviceIdHeader: 'Device ID',
    pageUserDevicesLocationHeader: 'Location Details',
    pageUserDevicesColumnHeaderName: 'Name',
    pageUserDevicesColumnHeaderType: 'Type',
    pageUserDevicesColumnHeaderCreation: 'Installed Date',
    pageUserDevicesColumnHeaderLastUsed: 'Last Used',
    pageUserDevicesColumnHeaderActions: 'Actions',
    pageUserDevicesStatusActive: 'Active',
    pageUserDevicesStatusInactive: 'Inactive',
    pageUserDevicesActionBlock: 'Block',
    pageUserDevicesActionAllow: 'Allow',
    pageUserDevicesConfirmRemoveModalContent:
      'Are you sure you want to remove ${deviceName}?',

    pageUserReportDesEncrypts:
      'Total encryptions and decryptions by operating system and application.',

    pageReportEncrypts: 'Encryptions',
    pageReportDecrypts: 'Decryptions',

    pageDashboardLicensed: 'Licensed',
    pageDashboardPending: 'Pending',
    pageDashboardUnlicensed: 'Unlicensed',
    pageDashboardUsers: 'Users',
    pageDashboardUsage: 'Usage',
    pageAddAliasModelAddPopupTitle: 'Add Alias',
    pageAddAliasModelValidEmail: 'Alias must be a valid email',
    pageAddAliasModelRequireEmail: 'Alias email is required',
    pageAddAliasModelEmailLabel: 'Alias Email:',
    pageAddAliasModelSubmitButton: 'Submit',
    pageAddAliasModelDescription:
      'Add an email that you would like to be able to use to create and open secure vaults with. An authentication email will be sent to confirm that you have access to it.',

    confirmMFAModalTitle: 'Setup Multi-Factor Authentication',
    confirmMFAModalDescription:
      'Complete the following steps to set up multi-factor authentication using your mobile device.',
    confirmMFAModalStep1:
      'Open or install your preferred authentication app on your mobile device (Authy, Microsoft Authenticator, Google Authenticator, etc.).',
    confirmMFAModalStep2: 'Scan the QR code below using the authentication app',
    confirmMFAModalStep2Troubleshoot:
      '<strong>Problem scanning the QR code?</strong><br />Enter the following information into your authentication app.<br />URL: https://datarock.biz/qrcode<br />Code: ${sharedKey}',
    confirmMFAModalStep3:
      'Enter the 6-digit verification code that should be displayed in the authentication app.',
    confirmMFAModalStep4:
      'Click the SUBMIT button to complete setting up multi-factor authentication.',
    confirmMFAModalCloseButton: 'Cancel',
    confirmMFAModalSubmitCodeButton: 'Submit',

    deleteAccountModalCloseButton: 'Cancel',
    deleteAccountModalConfirmButton: 'Permanently Delete Account',
    deleteAccountModalConfirmText: 'Type the word "DELETE"',
    deleteAccountModalTitle: 'Confirm Account Deletion',
    deleteAccountModalWarning:
      '<p>Account deletion will completely remove your Personally Identifiable Information (PII) from the Côntrol servers. Transaction records related to subscriptions may still be retained for regulatory compliance.</p><p><strong>Warning:</strong> Account deletions are permanent and <strong>CAN NOT</strong> be undone. You will lose access to all vaults secured with your account or vaults which you have been given access to by other authors. Others will still be able to open vaults you have previously given them access to.</p>Are you sure you would like to continue?',

    updatePasswordModalTitle: 'Update Password',
    updatePasswordAlertUpdatedSuccess: 'Password updated',
    updatePasswordModalCurrentPassword: 'Current Password',
    updatePasswordModalNewPassword: 'New Password',
    updatePasswordModalConfirmNewPassword: 'Confirm New Password',
    updatePasswordModalCloseButton: 'Close',
    updatePasswordModalUpdatePasswordButton: 'Update Password',

    multiFilterNotFoundAccessors: 'No accessors found',
    multiFilterNotFoundEventTypes: 'No event types found',
    multiFilterNotFoundCountries: 'No countries found',
    multiFilterNotFoundDetails: 'No details found',
    multiFilterNotFoundApplications: 'No applications found',
    multiFilterNotFoundPlatforms: 'No platforms found',
    multiFilterNoAccessorsData: 'No data for accessors',
    multiFilterNoCountriesData: 'No data for countries',
    multiFilterNoEventTypesData: 'No data for event types',
    multiFilterNoDetailsData: 'No details available',
    multiFilterNoApplicationsData: 'No data for applications',
    multiFilterNoPlatformsData: 'No data for platforms',
    multiFilterNoDataOwnersFound: 'No Data Owners Found',
    multiFilterNoDataOwners: 'No Data Owners',
    multiFilterPlaceHolderSearch: 'Search...',
    multiFilterPlaceHolderFileName: 'Filename...',
    multiFilterPlaceHolderTitle: 'Title...',
    multiFilterNoDataTypeFound: 'No Data Type Found',
    multiFilterCheckAll: 'Check All',
    multiFilterNoAttachment: 'No Attachment',
    multiFilterStartEndDateValidate:
      'Start date cannot be greater than the End date',
    multiFilterStartDate: 'Start Date:',
    multiFilterEndDate: 'End Date:',
    multiFilterStatus: 'Status',
    multiFilterActive: 'Active',
    multiFilterDraft: 'Draft',
    multiFilterRevoke: 'Revoke',
    multiFilterShred: 'Shred',
    multiFilterNoItemsMoreFound: 'No more items found',
    multiFilterNoStatusesFound: 'No Statuses Found',
    multiFilterNoRightsFound: 'No Rights Found',
    multiFilterMinimumMaximumValidate:
      'The Minimum value must be less than the Maximum value.',
    multiFilterFileSizeValidate: 'File size cannot be greater than 2048 MB.',
    multiFilterMinimum: 'Minimum (MB):',
    multiFilterMaximum: 'Maximum (MB):',
    multiFilterDateCreated: 'Date Created',
    multiFilterTitle: 'Title',
    multiFilterAccessors: 'Accessors',
    multiFilterSize: 'Size',
    multiFilterDataType: 'Data Type',
    multiFilterRights: 'Rights',
    multiFilterMore: 'More',
    multiFilterDate: 'Date',
    multiFilterUser: 'User',
    multiFilterEventType: 'Event Type',
    multiFilterDetails: 'Details',
    multiFilterApplication: 'Application',
    multiFilterPlatform: 'Platform',
    multiFilterCountry: 'Country',

    // Modal
    modalConfirmDiscardChangesWhileEditing:
      'Are you sure you want to discard the changes you made while editing the data?',
    modalConfirmDiscardChangesWhileAdding:
      'Are you sure you want to discard the changes you made while adding the data?',
    modalUnauthorized:
      'Your login is NOT authorized to access the Administrative Portal. Please use the button below to login to the User Portal.',

    // Toast
    toastSuccessMessage: 'Success! Your data has been saved.',
    toastResendAliasCodeMessage: 'Verification code sent successfully!',
    toastConfirmAliasCodeSuccessMessage: 'Your alias is now active!',
    toastBlockDeviceSuccessMessage: 'Success! Your device has been blocked.',
    toastAllowDeviceSuccessMessage: 'Success! Your device is now active.',
    toastDeleteAccountSucccessMessage:
      'Success! Your account has been deleted.',
    toastDeleteDeviceSuccessMessage: 'Success! Your device has been deleted.',
    toastChangePasswordSuccessMessage:
      'Success! Your password has been changed.',
    toastResetPasswordSuccessMessage: 'Success! Your password has been reset.',
    toastDeleteAliasSuccessMessage: 'Success! Your alias has been deleted.',
    toastDeleteDomainSuccessMessage: 'Success! Your domain has been deleted.',
    toastAdDomainSuccessMessage: 'Success! Your domain has been saved.',
    toastDeleteAuthorizedAccessorMessage:
      'Success! You have revoked access for ${email}',
    toastRevokeSuccessMessage: 'Success! Your vault has been Revoked.',
    toastShredSuccessMessage: 'Success! Your vault has been Shredded.',
    toastConfirmMFASucccessMessage: 'Success! MFA setup complete.',
    toastSelectCountryMessage:
      'You must select at least one country that the vault can be opened in.',

    // Error message
    errorMessageAbbreviationIsRequired: 'Abbreviation is required',
    errorMessageAddress1IsRequired: 'Address line 1 is required',
    errorMessageCityIsRequired: 'City is required',
    errorMessageStateTerritoryIsRequired: 'State/Territory is required',
    errorMessageNameIsRequired: 'Name is required',
    errorMessageCompanyTypeIsRequired: 'Company type is required',
    errorMessageNumbersOnly: 'Enter numbers only',
    errorMessageEmailValid: 'Enter a valid email',
    errorMessagePostalCodeIsRequired: 'Postal code is required',
    errorMessageTotalLicensesIsRequired: 'Total licenses is required',
    errorMessageCountryIsRequired: 'Country is required',
    errorMessagePasswordConfirmationIsRequired:
      'Password confirmation is required',
    errorMessagePasswordsDoNotMatch: 'Passwords do not match',
    errorMessageNewPasswordIsRequired: 'New password is required',
    errorMessageNewPasswordMustBeAtLeast8CharactersLong:
      'New password must be at least 8 characters long',
    errorMessageMustContain1UppercaseLetter:
      'Must contain at least 1 uppercase letter',
    errorMessageMustContain1LowercaseLetter:
      'Must contain at least 1 lowercase letter',
    errorMessageMustContain1Digit: 'Must contain at least 1 digit',
    errorMessageMustContain1SpecialCharacter:
      'Must contain at least 1 special character !@#$%^&*()+-_=[]{};\':"|,.<>/?`',
    errorMessageMustBeDifferentThanCurrentPassword:
      'Must be different from current password',
    errorMessageCurrentPasswordIsRequired: 'Current password is required',
    errorMessageCurrentPasswordMustBeAtLeast8Characters:
      'Current password must be at least 8 characters long',
    errorMessageEmailDoesNotMatch: 'Email does not match',
    errorMessageEmailIsRequired: 'Email is required',
    errorMessageValidEmail: 'Email must be a valid email',
    errorMessageMFACodeLength: 'Code needs to be 6 characters in length',
    errorMessageLicenseIsRequired: 'License is required',
    errorMessageRoleIsRequired: 'Role is required',

    // Trial functionality message
    userEBControlPoolFree:
      'Click the ‘Upgrade’ button to maximize the protection of your data with Côntrol!',
    userEBControlPoolTrial:
      'This free trial license will end ${date}. Click the ‘Upgrade’ button to keep enjoying the full benefits of Côntrol!',
    userEBControlPoolTrialExpired:
      'This free trial license ended ${date}. Click the ‘Upgrade’ button to again enjoy maximum control of your data with Côntrol!',
    userEBControlPoolProfessional:
      'This professional license will automatically renew on ${date}.',
    userEBControlPoolProfessionalExpired:
      'This professional license ended ${date}. Click the ‘Upgrade’ button to again enjoy maximum control of your data with Côntrol!',
    userOtherCompanyTrialExpired:
      'This trial license has expired. Please contact your company’s administrator regarding the status of your license.',
    userOtherCompanyProfessionalExpired:
      'This professional license has expired. Please contact your company’s administrator to renew your license.',
    userOtherCompanyClickHereMessage: 'Click here',
    userOtherCompanyMessage: ' to view details regarding company licenses.',

    // Popover
    popoverDeviveSelecting: 'Selecting',
    popoverDeviveBlock:
      'will prevent anyone from using Côntrol on that device.',
    popoverDeviveAllow: 'will enable Côntrol to be used on that device.',

    // Mouse activity detector
    inactivityWarning: 'Inactivity Warning',
    mouseActivityDes:
      'For security reasons, you will automatically be logged out of your session unless you click the CONTINUE button below.'
  }
});
